import $ from 'jquery';
import React, { Component } from 'react';
import CloseBtnIcon from '../assets/images/btn-close.svg';
import InfoIcon from '../assets/images/ic-info.svg';
const eu = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Belgium
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
  'GB', // United Kingdom
];

class CookieDisclaimer extends Component {
  componentDidMount() {
    fetch('/api/ip')
      .then(function(res) {
        return res.json();
      })
      .then(function(js) {
        let ip = js.ip;
        fetch(`https://ipapi.co/${ip}/json/`)
          .then(function(response) {
            return response.json();
          })
          .then(function(json) {
            try {
              if (eu.indexOf(json.country) >= 0) {
                const cookieDisclaimer = $('.cookie-disclaimer');
                let shownCookieDisclaimer = localStorage.getItem('scd');
                if (!shownCookieDisclaimer) {
                  cookieDisclaimer.css('display', 'flex');
                }

                $('.cookie-disclaimer .icon-close').click(() => {
                  cookieDisclaimer.remove();
                  localStorage.setItem('scd', 1);
                });
              }
            } catch (e) {
              console.log(e);
            }
          });
      });
  }

  render() {
    return (
      <div className="cookie-disclaimer" style={{ display: 'none' }}>
        <div className="icon-info">
          <img src={InfoIcon} alt="Info" />
        </div>
        <div className="message">
          Cookies help us deliver our services. By using our services you agree to our use of
          cookies and privacy policy.
          <br />
          You can turn cookies off by changing your browser settings.
        </div>
        <div className="icon-close">
          <button className="btn btn-default btn-sm">I AGREE</button>
        </div>
      </div>
    );
  }
}

export default CookieDisclaimer;



// WEBPACK FOOTER //
// ./src/components/CookieDisclaimer.js